<template lang="pug">
  div.changePwd
    van-form(@submit="onSubmit")
        van-field(class="changepwd_form", type="text", v-model="email", :placeholder="$t('plzInputId')", :rules="[{required: true, message: this.$t('idNull')},{ pattern: /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: this.$t('patternErr')}]")
        van-field(class="changepwd_form", type="password", v-model="newpwd", :placeholder="$t('inputNewPwd')", :rules="[{required: true, message: this.$t('pwdNull')},{validator: pwdValidator, message: pwdmsg}]", @input="inputMsg")
        van-field(class="changepwd_form", type="password", v-model="repeatpwd", :placeholder="$t('inputNewPwdAgain')", :rules="[{required: true, message: this.$t('inputNewPwdAgain')}, {validator: repeatValidator, message: repeatmsg}]")
        van-button(class="changepwd_btn", native-type="submit", type="danger", block, round, :disabled='isDisabled') {{$t('bind')}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'Faq',
  data(){
    return {
        email: '',
        newpwd: '',
        repeatpwd: '',
        isDisabled: false
    }
  },
  created(){
      
  },
  methods:{
    ...mapActions(['getUserInfo']),
    ...mapActions('user', ['upgradeEmail']),
    pwdValidator(val){
      if(val.length > 18 || val.length < 6){
        this.pwdmsg = this.$t('pwdPatternErr')
        return false
      }
    },
    inputMsg(val){
      const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@._#$;?&*,!'.split('')
      const pwd = this.newpwd.split('').map(v => {
        if(!str.includes(v)){
          this.newpwd = this.newpwd.replace(v, '')
        }
      })
    },
    onSubmit(){
        if(this.email && (this.newpwd === this.repeatpwd)){
          if(!this.isDisabled){
            this.upgradeEmail(Qs.stringify({
                appId: this.appid,
                uid: this.uid,
                deviceId: this.deviceId,
                accessToken: this.token,
                email: this.email,
                password: this.$md5(this.repeatpwd)
            }))
            this.isDisabled = true
          }
        }
    },
    repeatValidator(val){
        if(val !== this.newpwd){
            this.repeatmsg = this.$t('pwdDontmatch');
            return false
        }
        return true
    }
  },
  computed:{
    ...mapGetters(['appid', 'uid', 'deviceId', 'token', 'loading', 'userInfo']),
    ...mapGetters('user', ['errmsg', 'updateReturn', 'updateStatus']),
    pwdmsg: $vm => {
      return $vm.$t('pwdPatternErr')
    },
    repeatmsg: $vm => {
      return $vm.$t('pwdDontmatch')
    }
  },
  mounted(){
    this.$watch('updateStatus', val => {
      if(val === 'stated'){
        if(this.updateReturn === 'success'){
          typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.notifyBindSuccess(this.uid, this.email, this.$md5(this.repeatpwd)) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.notifyBindSuccess.postMessage({uid: this.uid, showName: this.email, password: this.$md5(this.repeatpwd)}))
        } else {
          this.isDisabled = false
        }
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.changePwd{
    margin: 20px;
    .changepwd_form{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .changepwd_btn{
        margin-top: 20px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>